import React, { useEffect, useState } from 'react';
import { Query } from 'react-apollo';
import { Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import Communicator from './Communicator';
import { measureHeight } from 'react-div-100vh';
import withSession from '../../lib/withSession';

import { removeRetellWidget } from '../../utils/retellWidget';

const DetailNavigation = styled.div`
  width: 100%;
  position: fixed;
  flex: 1;
  margin-bottom: 36px;
  z-index: 1;
`;

const BackButton = styled.div`
  background: rgba(180, 205, 244, 1);
  width: 100%;
  color: #333;
  padding: 6px 12px;
`;

const LoadingWrapper = styled(Flex)`
  flex-grow: 1;
  width: 100vw;
  height: calc(100vh - 120px);
  justify-content: center;
  align-items: center;
`;

const MobileCommunicatorPage = (props) => {
  const [isMobileSize, setIsMobileSize] = useState(null);
  useEffect(() => {
    if (window.innerWidth > 450) {
      setIsMobileSize(false);
    } else {
      setIsMobileSize(true);
    }

    const updateMedia = () => {
      if (window.innerWidth > 450) {
        setIsMobileSize(false);
      } else {
        setIsMobileSize(true);
      }
    };
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);

  return <>{!!isMobileSize ? <MobileCommunicatorPageInner {...props} /> : <DesktopCommunicatorPageInner {...props} />}</>;
};

class DesktopCommunicatorPageInner extends React.Component {
  constructor(props) {
    super(props);
    let isAsync = false;
    let isDesktopForced = false;
    let blockSend = false;

    if (props.location && props.location.state) {
      isAsync = props.location.state.isAsync;
      isDesktopForced = props.location.state.isDesktopForced;
      blockSend = props.location.state.blockSend;
    }
    this.state = {
      isAsync,
      isDesktopForced,
      blockSend,
    };
    removeRetellWidget();
    // if (window.Beacon) {
    //   // console.log('Beacon found');
    //   window.Beacon('destroy');
    // }
  }
  componentWillUnmount() {
    // console.log('window.onbeforeunload', window);
    // if (window.Beacon) {
    //   // console.log('window.onbeforeunload Beacon found');
    //   window.Beacon('init', '828e0d09-171b-4d1e-9d3c-dc4f59c81115');
    //   // window.Beacon('config', { display: '' });
    // }
  }
  render() {
    const { match, history } = this.props;
    const { isAsync, blockSend } = this.state;
    return (
      <Flex id="ppp" style={{ maxWidth: '490px', width: '100%', position: 'relative', height: '100%', paddingLeft: '20px' }}>
        <Flex flex={1} flexDirection="column">
          <Heading mb={4}>A Question For Your clinician?</Heading>
          <Communicator loadingWrapper={LoadingWrapper} isShowOnlyDesktop blockSend />
        </Flex>
      </Flex>
    );
  }
}
class MobileCommunicatorPageInner extends React.Component {
  constructor(props) {
    super(props);
    let isAsync = false;
    let isDesktopForced = false;
    let blockSend = false;

    if (props.location && props.location.state) {
      isAsync = props.location.state.isAsync;
      isDesktopForced = props.location.state.isDesktopForced;
      blockSend = props.location.state.blockSend;
    }
    this.state = {
      isAsync,
      isDesktopForced,
      blockSend,
    };
    removeRetellWidget();
    // if (window.Beacon) {
    //   // console.log('Beacon found');
    //   window.Beacon('destroy');
    // }
  }
  componentWillUnmount() {
    // console.log('window.onbeforeunload', window);
    // if (window.Beacon) {
    //   // console.log('window.onbeforeunload Beacon found');
    //   window.Beacon('init', '828e0d09-171b-4d1e-9d3c-dc4f59c81115');
    //   // window.Beacon('config', { display: '' });
    // }
  }
  render() {
    const { match, history } = this.props;
    const { isAsync, isDesktopForced, blockSend } = this.state;
    const vh100 = `${measureHeight()}px` || '100vh';
    const isMobileApp = !!window && !!window.ReactNativeWebView;
    const calc = `calc(${isMobileApp || vh100 === 'px' ? '100vh' : vh100} - ${isMobileApp ? '0px' : '100px'})`;
    return (
      <div style={{ maxWidth: '100vw', position: 'relative', maxHeight: calc }}>
        {!window.ReactNativeWebView &&
          !isDesktopForced && (
            <DetailNavigation>
              <BackButton
                onClick={() => {
                  history.goBack();
                }}
              >{`<  Your visit`}</BackButton>
            </DetailNavigation>
          )}
        <Communicator
          loadingWrapper={LoadingWrapper}
          blockSend={blockSend}
        />
      </div>
    );
  }
}

export default withSession(MobileCommunicatorPage);
